import { Season } from '@wbk/api';
import Fade from '../animation/Fade';

interface Props {
  season: Season;
}

const SeasonTicketPoints = ({ season }: Props) => {
  if (!season?.benefits.length) return null;

  return (
    <div className='container relative z-10 grid grid-cols-2 gap-x-5 gap-y-10 md:grid-cols-3 md:gap-10 lg:grid-cols-4'>
      {season.benefits.map((benefit, i) => (
        <Fade delay={0.1 * i} className='flex flex-col items-center gap-2' key={i}>
          <svg
            width='40'
            height='40'
            viewBox='0 0 54 54'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              fillRule='evenodd'
              clipRule='evenodd'
              d='M19.3518 50.5382L27 47.9231L34.6482 50.5382L39.2985 43.927L47.0232 41.5473L46.8994 33.4653L51.75 26.9996L46.8994 20.5339L47.0232 12.4519L39.2985 10.0721L34.6482 3.46094L27 6.0761L19.3518 3.46094L14.7015 10.0721L6.97683 12.4519L7.10058 20.5339L2.25 26.9996L7.10058 33.4653L6.97683 41.5473L14.7015 43.927L19.3518 50.5382ZM39.8138 16.3866C38.9417 15.4941 37.5749 15.5457 36.7609 16.502L23.0537 32.6054L17.0657 26.9777C16.16 26.1264 14.7964 26.2414 14.02 27.2345C13.2437 28.2277 13.3486 29.7229 14.2543 30.5741L21.8143 37.6794C22.6931 38.5053 24.0094 38.4249 24.7991 37.4972L39.9191 19.734C40.733 18.7778 40.6859 17.2791 39.8138 16.3866Z'
              fill='currentColor'
            />
          </svg>
          <div className='text-center'>
            <h3 className='text-lg font-bold md:text-xl'>{benefit.title}</h3>
            {benefit.description && <p className='text-sm'>{benefit.description}</p>}
          </div>
        </Fade>
      ))}
    </div>
  );
};

export default SeasonTicketPoints;
